import { render, staticRenderFns } from "./TableActiveModal.vue?vue&type=template&id=0179f20e&scoped=true&"
import script from "./TableActiveModal.vue?vue&type=script&lang=js&"
export * from "./TableActiveModal.vue?vue&type=script&lang=js&"
import style0 from "./TableActiveModal.vue?vue&type=style&index=0&id=0179f20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179f20e",
  null
  
)

export default component.exports